import styled from 'styled-components';

import {mixins} from '@edna/components/styles';

import BaseTabs, {Tab as BaseTab} from '../Tabs';
import {RouterLink as BaseRouterLink} from '../primitives';

export const Tabs = styled(BaseTabs)<{noMargin?: boolean}>`
  margin-bottom: ${({theme, noMargin}) => (noMargin ? 0 : theme.spacing.s6)};
`;
export const Tab = styled(BaseTab)`
  ${mixins.f4}
  font-weight: 500;
`;

export const TabsIcon = styled.svg`
  flex-shrink: 0;
  margin-right: ${({theme}) => theme.spacing.s2};
`;

export const RouterLink = styled(BaseRouterLink)`
  &:hover {
    text-decoration: none;
  }
`;
